import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Grid, CircularProgress } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      minHeight: '100vh'
    }
  })
);

const AppFallback = () => {
  const classes = useStyles();

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      className={classes.container}
    >
      <Grid item xs={3}>
        <CircularProgress size={64} />
      </Grid>
    </Grid>
  );
};

export default AppFallback;
